import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { beneLookUp } from "../../../../redux/features/verifyPAN/verifyPAN";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import { beneBankLookUp } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import {
  viewAccountDetail,
  ReimburseApproveAccount,
  ReimburseRejectAccount,
} from "../../../../redux/features/accounts/ReimburseAccount";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const CreateSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [rejectPopup, setRejectPopup] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    beneAccountId: "",
    name: "",
    bankAccountName: "",
    bankAccountNo: "",
    bankAccountIFSC: "",
    categories: "",
    pan: "",
    labels: "",
  });

  const services = useSelector((state) => state.refreshToken.services);

  const { viewAccountDetailData } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const beneLookData = useSelector((state) => state.verify);

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const accountData = viewAccountDetailData?.reimbursement_accounts?.[0];

  useEffect(() => {
    if (accountData) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = accountData;
      setCurrentAccountDetails({
        beneAccountId: id,
        name,
        bankAccountName: bank_name,
        bankAccountNo: bank_acc_no,
        bankAccountIFSC: ifsc_code,
        categories: category,
        pan: pan_no,
        labels: labels,
      });
    }
  }, [accountData]);

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);

  const approveAcc = async () => {
    try {
      await dispatch(ReimburseApproveAccount(id)).unwrap();

      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        {
          replace: true,
        },
      );
    } catch (err) {
      console.error("Approval failed", err);
    }
  };
  const RejectAcc = async ({ id, AccountIdData }) => {
    try {
      await dispatch(ReimburseRejectAccount({ id, AccountIdData }));
      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        {
          replace: true,
        },
      );
    } catch (err) {
      console.error("Rejected failed", err);
    }
  };

  const createTxnHandler = () => {
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
      {
        state: currentAccountDetails,
      },
    );
  };

  const createAccountHandler = () => {
    navigate("/reimbursement_account_dashboard/create_reimbursement_account");
  };

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard");
  };

  const buttonRows = [
    ...(services?.includes("RAAccount") || services?.includes("Admin")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_CIRCLE_RED_ICON,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECTED_WITH_WHITE_FILLED,
              handleFunction: () => {
                approveAcc();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),

    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createTxnHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];
  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };
  const AccountIdData = declineReason;

  return (
    <div>
      {rejectPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex bg-custom-backdrop bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            subtext="Please state the reason for rejecting the account"
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            noteText=" The reason must consist of at least 10 characters."
            inputPlaceholder="Reason"
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              handleInputChange(e);
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneHandleFunction={() => {
              setRejectPopup(false);
            }}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="trans"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={!declineReason || declineReason.length < 10}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              RejectAcc({ id, AccountIdData });
            }}
            btnTwoBtnType="submit"
          />
        </div>
      )}
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          location?.state?.type === "switch_account"
            ? "Beneficiary account successfully switched to reimbursement account"
            : "Reimbursement account created successfully and awaiting approval."
        }
      >
        <TabsWeapperSection title="Account details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(accountData?.name),
                  leftSubTitle: "Account name",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.bank_acc_no,
                  leftSubTitle: "Account number",
                  ifsc: accountData?.ifsc_code,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.ifsc_code,
                  leftSubTitle: "IFSC code",
                },
              ]}
            />
            {accountData?.virtual_account === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle:
                      accountData?.virtual_account_type === "manual"
                        ? "Manually created"
                        : "Auto detected",
                    leftSubTitle: "Virtual account",
                  },
                ]}
              />
            )}
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.category,
                  leftSubTitle: "Categories",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.pan_no,
                  leftSubTitle: "PAN number",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.gstin_detail ?? "Not given",
                  leftSubTitle: "GST number (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    accountNameStandardised(
                      accountData?.reimbursement_user_full_name,
                    ) ?? "Not linked",
                  leftSubTitle: "User",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.contact_no,
                  leftSubTitle: "Contact number",
                  icon: ICONS.CONTACT_NO,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.email_id,
                  leftSubTitle: "Email ID",
                  icon: ICONS.GMAIL_RED_ERROR,
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.labels
                    ? accountData.labels.join(",")
                    : "Not assigned",
                  leftSubTitle: "Labels (optional)",
                },
              ]}
            />
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountData?.recipient_email
                    ? accountData?.recipient_email.join(",")
                    : "Not assigned",
                  leftSubTitle: "Recipents (optional)",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
        {beneLookData?.beneLookData?.beneficiary_accounts.length >
          GlobalConfiguration.lengthCheckOne && (
          <TabsWeapperSection title="Accounts Associated to PAN">
            {beneLookData?.beneLookData?.beneficiary_accounts
              ?.filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountNameStandardised(
                    accountData?.bank_account_holder_full_name,
                  )}
                  leftHeaderWidth="w-width-lg"
                  rows={[
                    {
                      leftTitle: accountData?.bank_acc_no,
                      leftSubTitle: "Bank account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}

        {benebankLookData?.reimbursement_accounts?.length >
          GlobalConfiguration.lengthCheckOne && (
          <TabsWeapperSection title="Accounts Associated to Bank">
            {benebankLookData?.reimbursement_accounts
              .filter(
                (accountData) =>
                  accountData?.approval_status === "pending" ||
                  accountData?.approval_status === "approved",
              )
              .map((accountData, id) => (
                <InfoCard
                  key={id}
                  bgColor="var(--positive-card)"
                  header={true}
                  borderColor="var(--positive-bg)"
                  rightHeaderText={`${
                    accountData?.approval_status?.charAt(0).toUpperCase() +
                    accountData?.approval_status?.slice(1)
                  } account`}
                  rightHeaderTextColor="var(--text-secondary)"
                  leftHeaderText={accountNameStandardised(accountData?.name)}
                  showTopArrow={false}
                  rows={[
                    {
                      leftTitle: accountData?.pan_no,
                      leftSubTitle: "PAN number",
                    },
                  ]}
                />
              ))}
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </div>
  );
};

export default CreateSuccess;
